import { render, staticRenderFns } from "./ArticleText.vue?vue&type=template&id=73ca475f"
import script from "./ArticleText.vue?vue&type=script&lang=js"
export * from "./ArticleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports